// Erros tipados emitidos pelo SDK.
// Consumidor pode discriminar via instanceof.

export class InfosaasError extends Error {
  readonly code: string

  constructor(message: string, code: string) {
    super(message)
    this.name = this.constructor.name
    this.code = code
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export class NotFoundError extends InfosaasError {
  constructor(entity: string, identifier?: string | number) {
    super(
      identifier !== undefined ? `${entity} not found: ${identifier}` : `${entity} not found`,
      'NOT_FOUND',
    )
  }
}

export class AccessDeniedError extends InfosaasError {
  constructor(message = 'Access denied') {
    super(message, 'ACCESS_DENIED')
  }
}

export class ValidationError extends InfosaasError {
  readonly issues: unknown

  constructor(message: string, issues?: unknown) {
    super(message, 'VALIDATION_ERROR')
    this.issues = issues
  }
}

export class SupabaseError extends InfosaasError {
  readonly cause: unknown

  constructor(message: string, cause?: unknown) {
    super(message, 'SUPABASE_ERROR')
    this.cause = cause
  }
}

export function isNotFoundError(err: unknown): err is NotFoundError {
  return err instanceof NotFoundError
}

export function isAccessDeniedError(err: unknown): err is AccessDeniedError {
  return err instanceof AccessDeniedError
}
